import React from "react"
import { FaFilter } from "react-icons/fa"

import { IconButton } from "components"
import classes from "./OrderFilterButton.module.scss"

const OrderFilterButton = props => {
  const { filters, setOpenFilterSidebar } = props

  const getNumberOfFilters = () => {
    let result = 0

    if (!!filters.fromDate) {
      result++
    }

    if (!!filters.addedBySystem) {
      result++
    }

    if (!!filters.branch) {
      result++
    }

    if (!!filters.account) {
      result++
    }

    if (!!filters.addedByAccount) {
      result++
    }

    if (!filters.isViewed) {
      result++
    }

    if (!!filters.deliveryType) {
      result++
    }

    return result
  }

  const numberOfFilters =
    getNumberOfFilters()

  return (
    <IconButton
      icon={FaFilter}
      size={12}
      color="white"
      badge={numberOfFilters}
      onClick={() => setOpenFilterSidebar(true)}
      className={classes["filter"]}
    />
  )
}

export default OrderFilterButton